import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ccd56cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "button",
  class: "course-card"
}
const _hoisted_2 = { class: "course-badge" }
const _hoisted_3 = {
  key: 0,
  class: "badge-free"
}
const _hoisted_4 = {
  key: 1,
  class: "badge-premium"
}
const _hoisted_5 = { class: "card-header-bg border-0 d-flex items-center justify-content-center" }
const _hoisted_6 = { class: "card-title m-0" }
const _hoisted_7 = { class: "image-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "card-body-wrapper" }
const _hoisted_10 = { class: "card-body-content" }
const _hoisted_11 = { class: "status-badges-container" }
const _hoisted_12 = {
  key: 0,
  class: "status-badge status-not-started"
}
const _hoisted_13 = {
  key: 1,
  class: "status-badge status-completed"
}
const _hoisted_14 = {
  key: 2,
  class: "status-badge status-in-progress"
}
const _hoisted_15 = { class: "course-name" }
const _hoisted_16 = { class: "course-description" }
const _hoisted_17 = { class: "button-container" }
const _hoisted_18 = { class: "watch-course-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {name: 'training-module-list', params: {id: _ctx.course.id}}
  }, {
    default: _withCtx(() => [
      _createElementVNode("a", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.course.is_freemium)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " FREE "))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.only_for_members`).toUpperCase()), 1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.course.image_url,
                alt: "image",
                class: "course-image"
              }, null, 8, _hoisted_8)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.course.user_status == 'not-started')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.not_started_yet`).toUpperCase()), 1))
                : _createCommentVNode("", true),
              (_ctx.course.user_status == 'completed')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.completed`).toUpperCase()), 1))
                : _createCommentVNode("", true),
              (_ctx.course.user_status == 'started')
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`).toUpperCase()), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.course.name), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.course?.description), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.watch_course`)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}